/* eslint-disable */
"use client";

import { useCallback, useEffect, useState } from "react";
// import PrivacyConsentModal from "@/components/common/PrivacyConsentModal";  
import TermsConsentModal from "@/components/common/TermsConsentModal";
import PasswordChangePromptModal from "@/components/common/PasswordChangePromptModal";
import JobSelectionModal from "@/components/common/JobSelectionModal";
import InterestSelectionModal from "@/components/common/InterestSelectionModal";
import SessionExpiredModal from "@/components/common/SessionExpiredModal";
import { clearAuthCache, getAuthStatus } from "@/lib/auth";
import { useSessionMonitor } from "@/hooks/useSessionMonitor";
import { authService } from "@/services/auth.service";

export default function PrivacyConsentGate() {
  const [open, setOpen] = useState(false);
  const [showTermsConsent, setShowTermsConsent] = useState(false);
  const [pwdPrompt, setPwdPrompt] = useState(false);
  const [showJob, setShowJob] = useState(false);
  const [showInterest, setShowInterest] = useState(false);
  const [firstLoginFlow, setFirstLoginFlow] = useState(false);
  const [pendingUserCode, setPendingUserCode] = useState<string | null>(null);
  const [pendingUserEmail, setPendingUserEmail] = useState<string | null>(null);
  const [pendingUserId, setPendingUserId] = useState<string | null>(null);

  // 세션 모니터링 (중복 로그인 방지)
  const { showSessionExpiredModal, handleSessionExpiredConfirm } = useSessionMonitor({
    onSessionInvalid: () => {
      // console.log('[PrivacyConsentGate] Session invalidated, clearing auth cache');
      clearAuthCache();
      // 모든 모달 닫기
      setOpen(false);
      setShowTermsConsent(false);
      setPwdPrompt(false);
      setShowJob(false);
      setShowInterest(false);
    },
  });

  useEffect(() => {
    // activate 플로우인지 확인
    const isActivateFlow = sessionStorage.getItem('activateFlow');
    if (isActivateFlow) {
      // activate 플로우는 메인 페이지에서 처리하므로 여기서는 무시
      // console.log('PrivacyConsentGate - Activate flow detected, skipping');
      return;
    }

    // 일반 로그인 사용자의 정보동의 체크
    let mounted = true;
    getAuthStatus()
      .then((data) => {
        if (!mounted) return;
        // console.log('PrivacyConsentGate - Auth data:', data);
        const needs = !!data?.needsConsent;
        // console.log('PrivacyConsentGate - needsConsent:', needs);
        
        // 로그인 상태이면서 동의가 필요한 경우
        if (data?.ok === true && needs) {
          // console.log('PrivacyConsentGate - Opening terms consent modal for logged-in user');
          setPendingUserCode(data.user?.id || null);
          setPendingUserEmail(data.user?.email || null);
          setShowTermsConsent(true);
        }
        
        // approval_code가 pending인지 확인 (최초 비밀번호 변경)
        if (data?.ok === true && data?.user?.approvalCode === 'pending' && !needs) {
          // console.log('PrivacyConsentGate - Pending approval detected, showing password change');
          // console.log('PrivacyConsentGate - approvalCode:', data.user.approvalCode);
          // console.log('PrivacyConsentGate - user ID:', data.user?.id);
          setPendingUserId(data.user?.id || null);
          setFirstLoginFlow(true);
          setPwdPrompt(true);
        }
      })
      .catch(() => setOpen(false));
    return () => { mounted = false; };
  }, []);
  // 코드 로직상 open 플래그는 사용하지 않음
  // const onAgree = useCallback(async () => {
  //   // 일반 로그인 사용자의 정보동의 처리
  //   try {
  //     const res = await authService.termsConsent({
  //       serviceAgreed: true,
  //       privacyAgreed: true,
  //       marketingAgreed: false
  //     });
  //     if (res.code === "SUCCESS") {
  //       setOpen(false);
  //       // 정보동의 후 lastLogin이 null이면 비밀번호 변경 모달 표시
  //       const authData = await getAuthStatus();
  //       if (authData?.ok === true && authData?.user?.lastLogin === null) {
  //         setFirstLoginFlow(true);
  //         setPwdPrompt(true);
  //       }
  //     }
  //   } catch {}
  // }, []);

  // const onDisagree = useCallback(async () => {
  //   try {
  //     const res = await authService.privacyConsent({
  //       agreed: false
  //     });
  //     if (res.code === "SUCCESS") {
  //       setOpen(false);
  //       try { (globalThis as any).__dw_latest_auth__ = false; } catch {}
  //       clearAuthCache();
  //       window.location.reload();
  //     }
  //   } catch {
  //     try { (globalThis as any).__dw_latest_auth__ = false; } catch {}
  //     clearAuthCache();
  //     window.location.reload();
  //   }
  // }, []);

  const handleTermsConsentAgree = useCallback(async (consents: any) => {
    console.log('[PrivacyConsentGate] Terms consent completed:', consents);
    setShowTermsConsent(false);
    
    // 약관 동의 완료 후 lastLogin이 null이면 비밀번호 변경 모달 표시
    const authData = await getAuthStatus();
    if (authData?.ok === true && authData?.user?.lastLogin === null) {
      setFirstLoginFlow(true);
      setPwdPrompt(true);
    }
  }, []);

  const handleTermsConsentClose = useCallback(() => {
    setShowTermsConsent(false);
    setPendingUserCode(null);
  }, []);

  return (
    <>
      {/* <PrivacyConsentModal open={open} onClose={() => setOpen(false)} onAgree={onAgree} onDisagree={onDisagree} /> */}
      <PasswordChangePromptModal
        open={pwdPrompt}
        onClose={() => { setPwdPrompt(false); if (firstLoginFlow) setShowJob(true); }}
        onChange={() => { 
          // console.log('[PrivacyConsentGate] PasswordChangePromptModal onChange called');
          // console.log('[PrivacyConsentGate] firstLoginFlow:', firstLoginFlow);
          // console.log('[PrivacyConsentGate] Current URL before onChange:', typeof window !== 'undefined' ? window.location.href : 'N/A');
          setPwdPrompt(false); 
          if (firstLoginFlow) {
            // console.log('[PrivacyConsentGate] Setting showJob to true');
            setShowJob(true); 
          }
          // console.log('[PrivacyConsentGate] Current URL after onChange:', typeof window !== 'undefined' ? window.location.href : 'N/A');
        }}
        isFirstLogin={firstLoginFlow}
        isInitialPassword={firstLoginFlow}
        userIdx={pendingUserId || (typeof window !== 'undefined' ? sessionStorage.getItem('pendingUserIdx') || undefined : undefined)}
      />
      {/* 최초 로그인 온보딩 연속 모달: 비밀번호 변경 페이지에서 돌아온 뒤 동작하도록 표시 플래그 제어 */}
      <JobSelectionModal
        open={!open && !pwdPrompt && firstLoginFlow && showJob}
        onClose={() => setShowJob(false)}
        onSkip={() => { setShowJob(false); setShowInterest(true); }}
        onNext={async (job) => {
          // 저장 지연: 관심사까지 선택한 뒤 한번에 저장
          (window as any).__dw_pending_job__ = job ?? null;
          setShowJob(false);
          setShowInterest(true);
        }}
      />
      <InterestSelectionModal
        open={!open && !pwdPrompt && firstLoginFlow && showInterest}
        onClose={() => setShowInterest(false)}
        onBack={() => { setShowInterest(false); setShowJob(true); }}
        onSave={async (interests) => {
          try {
            const job = (window as any).__dw_pending_job__ ?? null;
            // interests는 코드 배열로 전달됨
            const codes = Array.from(new Set(interests ?? []));
            const res = await authService.savePersonalization({
              job,
              interests: codes
            });
            if (res.code === "SUCCESS") {
              // 마이페이지와 동일하게 성공 시 이벤트 발생
              try { window.dispatchEvent(new CustomEvent('dw:personalization_saved')); } catch {}
            } else {
              console.error('개인화 정보 저장 실패:', res.details?.reason);
            }
          } catch (error) {
            console.error('개인화 정보 저장 오류:', error);
          }
          setShowInterest(false);
          try { (window as any).__dw_latest_auth__ = true; } catch {}
        }        }
      />
      <TermsConsentModal
        open={showTermsConsent}
        onClose={handleTermsConsentClose}
        onAgree={handleTermsConsentAgree}
        userCode={pendingUserCode || undefined}
        userEmail={pendingUserEmail || undefined}
      />
      <SessionExpiredModal
        open={showSessionExpiredModal}
        onConfirm={handleSessionExpiredConfirm}
      />
    </>
  );
}


